module.exports = __webpack_public_path__ + "static/media/scroll3_5_2.b6eb40e8.png";